<template>
    <div class="acomodar">
        
      <AdministracionVue/>  
    </div>
</template>

<script>
import AdministracionVue from '@/components/RegistrarLink/Administracion.vue';
export default {
    name: 'BYAdministrador',
    components:{
        AdministracionVue
    },

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  margin-top: 9px;
  margin-bottom: 12px;
  width: 100%;
  background: rgb(255, 255, 255);
  margin-left: 0.25%;
  margin-right: 10px;
  height: auto;
  border-radius: 10px 10px 10px 10px;
  overflow-x: auto;
  overflow-y :auto;

  padding-top: 2%;
}
</style>